<div class="row form-group" *ngIf="ui[id]">
  <div class="offset-sm-6 col-sm-6">
    <div class="alert alert-secondary">
      <button type="button" class="close" aria-label="Close" (click)="onClose()">
        <span aria-hidden="true">&times;</span>
      </button>
      <ng-content></ng-content>
    </div>
  </div>
</div>